//this will conditionally wrap elements.
export default ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);
